"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

var warnOnce =require("@atlaskit/ds-lib/warn-once").default

warnOnce("The '@atlaskit/icon-priority' package has been deprecated due to its limited usage in Cloud Products. If you depend on '@atlaskit/icon-priority' we recommend self-managing the assets.")

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PriorityMinorIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M18.449 14.975a1 1 0 011.027 1.716l-6.97 4.173a1 1 0 01-1.03-.002L4.57 16.69a1 1 0 011.034-1.712l6.391 3.862 6.454-3.864z" fill="#0065FF"/><path d="M11.995 12.837l6.454-3.865a1 1 0 011.027 1.716l-6.97 4.174a1 1 0 01-1.03-.002L4.57 10.686a1 1 0 011.034-1.712l6.391 3.863z" fill="#2684FF"/><path d="M11.995 6.823l6.454-3.865a1 1 0 111.027 1.716l-6.97 4.174a1 1 0 01-1.03-.002L4.57 4.672A1 1 0 015.604 2.96l6.391 3.863z" fill="#4C9AFF"/></svg>`
}, props));

PriorityMinorIcon.displayName = 'PriorityMinorIcon';
var _default = PriorityMinorIcon;
exports.default = _default;
